import React, { useState, useEffect, useCallback, useRef } from 'react'
import { logListPromise } from 'api/Log'
import LogListTable from './components/LogListTable'
import LogListToolbar from './components/LogListToolbar'
import { useLocation } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import _ from 'lodash'

const LogList = props => {
  const ref = useRef()
  const location = useLocation()
  const [logs, setLogs] = useState({})
  const [params, setParams] = useState({ page: 1 })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    logListPromise(too).then(resp => setLogs(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }
  // end

  return (
    <div className={'root'}>
      <div className={'content'}>
        <LogListToolbar params={params} handleChange={handleParamsChange} {...props} />
        <br />
        <LogListTable {...props} page={params.page} data={logs} onPageChange={handlePageChange} />
      </div>
    </div>
  )
}

export default LogList